/**
 * Маски и проверки контактных данных.
 *
 * Проверки дублируются на сервере: клиентские нужны для подсказок, а не
 * для защиты — их легко обойти через консоль.
 */

const PHONE_TEMPLATE = '+7 (___) ___-__-__';

/** Приводит любой ввод к виду +7 (900) 000-00-00. */
export function formatPhone(raw: string): string {
  let digits = raw.replace(/\D/g, '');

  // 8 и 7 в начале означают одну и ту же российскую восьмёрку
  if (digits.startsWith('8')) digits = `7${digits.slice(1)}`;
  if (!digits.startsWith('7')) digits = `7${digits}`;
  digits = digits.slice(0, 11);

  const rest = digits.slice(1);
  let result = '';
  let index = 0;

  for (const char of PHONE_TEMPLATE) {
    if (char !== '_') {
      if (index === 0 && char === '(') {
        if (rest.length === 0) break;
      }
      result += char;
      continue;
    }
    if (index >= rest.length) break;
    result += rest[index];
    index += 1;
  }

  return result.trimEnd();
}

export function isPhoneComplete(value: string): boolean {
  return value.replace(/\D/g, '').length === 11;
}

// Умышленно строже общего стандарта: домен с точкой и зоной от двух букв.
// Так отсекаются опечатки вроде mail@mail и явный мусор.
const EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

export function isEmailValid(value: string): boolean {
  return EMAIL.test(value.trim()) && value.length <= 254;
}

/** Имя и фамилия буквами, допускаются дефис и апостроф. */
const FULL_NAME = /^[А-Яа-яЁёA-Za-z][А-Яа-яЁёA-Za-z'-]*(\s+[А-Яа-яЁёA-Za-z][А-Яа-яЁёA-Za-z'-]*)+$/;

export function isFullNameValid(value: string): boolean {
  const trimmed = value.trim();
  return FULL_NAME.test(trimmed) && trimmed.length <= 100;
}

export function isAddressValid(value: string): boolean {
  const trimmed = value.trim();
  // Адрес без цифр почти наверняка неполный: нет дома или квартиры
  return trimmed.length >= 10 && /\d/.test(trimmed);
}
